import { IGetVenuesResponseData } from 'src/api/getVenues/types';
import { IPricingChannel } from 'src/helpers/channels/getPricingChannels';

export const NOT_SET_UP_FOR_CHANNELS = 'Not set up for defined channel(s)';

export const getVenueSystemIds = (venue: IGetVenuesResponseData): string[] =>
  (venue.external_identifiers ?? []).map((identifier) => identifier.external_system_id);

/**
 * Channel selection is made per extension instance, but a venue only records which external
 * systems it's set up with - so a selected instance has to be resolved back to its system id
 * before it can be matched against a venue.
 */
export const getSelectedSystemIds = (selectedInstanceIds: string[], channels: IPricingChannel[]): Set<string> => {
  const instanceToSystemId = new Map(channels.map((channel) => [channel.extensionInstanceId, channel.aggregatorId]));
  const systemIds = selectedInstanceIds.map((id) => instanceToSystemId.get(id)).filter((id): id is string => !!id);
  return new Set(systemIds);
};

export const isVenueEligibleForChannels = (venue: IGetVenuesResponseData, selectedSystemIds: Set<string>): boolean => {
  if (selectedSystemIds.size === 0) return true;
  return getVenueSystemIds(venue).some((id) => selectedSystemIds.has(id));
};

/**
 * The channel names shown as a venue's subtext - narrowed to the selected channels when any are
 * selected, or every channel the venue is set up with otherwise.
 */
export const getVenueChannelNames = (venue: IGetVenuesResponseData, selectedSystemIds: Set<string>): string[] => {
  const identifiers = venue.external_identifiers ?? [];
  const relevant =
    selectedSystemIds.size > 0
      ? identifiers.filter((identifier) => selectedSystemIds.has(identifier.external_system_id))
      : identifiers;
  return Array.from(new Set(relevant.map((identifier) => identifier.external_system_name)));
};
